import { shape, string, number } from "prop-types"

export const ChargeRateShape = shape({
    classificationId: string.isRequired,
    rate: number.isRequired
})